// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"ModalLayout-desktop__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/layouts/ModalLayout/ModalLayout.desktop.scss
 ** module id = 953
 ** module chunks = 1
 **/